import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from '../auth.service';
import {inject} from '@angular/core';
import {notificationsParams} from "../../shared/settings";
import {NbToastrService} from "@nebular/theme";

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const toastrService = inject(NbToastrService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        return throwError(() => new Error('Connection lost. Please check your internet connection.'));
      }
      else if (error.status === 401) {
        authService.logout().subscribe(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.assign(authService.getAuthLoginUrl());
        });
      }
      toastrService.danger(error?.error?.message, 'Error', notificationsParams);
      return throwError(() => error);
    })
  );
}
